/*
 * Variant picker — porta ProductForm.tsx (pills por opção) sem navegação:
 * resolve o variant a partir das opções selecionadas, atualiza preço,
 * disponibilidade, botão de compra e ?variant= na URL (replaceState,
 * paridade com o navigate({replace: true}) do original).
 */
function initPicker(picker) {
  const variants = JSON.parse(
    picker.querySelector('[data-variants-json]')?.textContent || '[]',
  );
  if (!variants.length) return;

  const form = picker.querySelector('[data-product-form]');
  const priceContainer = picker
    .closest('.product-main')
    ?.querySelector('[data-price-container]');
  const optionButtons = [...picker.querySelectorAll('[data-option-value]')];
  const positions = [...new Set(optionButtons.map((b) => Number(b.dataset.optionPosition)))].sort();

  const selected = {};

  function currentVariant() {
    return variants.find((v) =>
      positions.every((pos, i) => {
        const value = selected[pos];
        return value === undefined || v.options[pos - 1] === value;
      }),
    );
  }

  function variantMatching(position, value) {
    return variants.filter((v) =>
      positions.every((pos) => {
        const want = pos === position ? value : selected[pos];
        return want === undefined || v.options[pos - 1] === want;
      }),
    );
  }

  function render() {
    const variant = currentVariant();

    optionButtons.forEach((button) => {
      const pos = Number(button.dataset.optionPosition);
      const value = button.dataset.optionValue;
      const matches = variantMatching(pos, value);
      const exists = matches.length > 0;
      const available = matches.some((v) => v.available);
      const isSelected = selected[pos] === value;

      button.disabled = !exists;
      button.classList.toggle('link', exists && !isSelected);
      button.style.background = isSelected ? 'black' : 'transparent';
      button.style.color = isSelected ? 'white' : 'black';
      button.style.border = '2px solid black';
      button.style.opacity = available ? '1' : '0.3';
    });

    if (!variant) return;

    if (form) {
      form.querySelector('[data-variant-id]').value = variant.id;
      const button = form.querySelector('[data-add-to-cart]');
      const text = form.querySelector('[data-add-to-cart-text]');
      if (button) button.disabled = !variant.available;
      if (text) {
        text.textContent = variant.available ? 'Adicionar ao carrinho' : 'Sold out';
      }
    }

    if (priceContainer) {
      if (variant.compare_at_formatted) {
        priceContainer.innerHTML = `<div class="product-price-on-sale"><span data-price>${variant.price_formatted}</span><s><span data-compare-price>${variant.compare_at_formatted}</span></s></div>`;
      } else {
        priceContainer.innerHTML = `<span data-price>${variant.price_formatted}</span>`;
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // Estado inicial: ?variant= da URL ou o variant selecionado no servidor.
  const urlVariantId = Number(new URLSearchParams(window.location.search).get('variant'));
  const initialId = urlVariantId || Number(form?.querySelector('[data-variant-id]')?.value);
  const initial = variants.find((v) => v.id === initialId) || variants[0];
  positions.forEach((pos) => {
    selected[pos] = initial.options[pos - 1];
  });
  render();

  optionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const pos = Number(button.dataset.optionPosition);
      if (selected[pos] === button.dataset.optionValue) return;
      selected[pos] = button.dataset.optionValue;
      render();
    });
  });

  // view_item / ViewContent — paridade com trackViewContent no PDP.
  if (window.HighAnalytics && form) {
    window.HighAnalytics.trackViewContent({
      id: form.dataset.productGid,
      title: form.dataset.productTitle,
      price: initial.price,
      category: form.dataset.productVendor,
    });
  }
}

function init() {
  document.querySelectorAll('[data-variant-picker]').forEach(initPicker);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
